import { getMessageFactory } from "../getCaxaWebSocket.js";
const resizeWindowSize = getMessageFactory({
  code: "RESIZE_WINDOW_SIZE"
});
export { resizeWindowSize };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/resizeWindowSize.js